export default __webpack_public_path__ + "images/4c26a10cc6f11cf16c8fa80d087265b2.svg";